import { useAuthTokenError, $axios } from '../utils'
import { validateCreateReply } from '../validators/replies.validators'
import '../typedefs'

/**
 * Gets replies for a single prayer request id
 * @param {String} authToken Auth token
 * @param {String} id prayer request id
 * @returns {import('axios').AxiosResponse<{ message: String, data: Reply[] }>}
 */
export function getRepliesById (authToken, id) {
  useAuthTokenError(authToken)

  return $axios(`/prayerRequests/${id}/prayerRequestReplies`, {
    headers: {
      'x-access-token': authToken
    }
  })
}

/**
 * Creates a prayer request reply
 * @param {String} authToken Auth token
 * @param {Reply} payload prayer request reply payload
 * @returns {import('axios').AxiosResponse<{ message: String, data: Reply }>}
 */
export function createReply (authToken, payload) {
  useAuthTokenError(authToken)
  validateCreateReply(payload)
  return $axios('/prayerRequests/prayerRequestReplies', {
    method: 'POST',
    headers: {
      Authorization: authToken,
      'x-access-token': authToken
    },
    data: payload
  })
}

/**
 * Gets a single reply to a prayer request.
 * @param {String} authToken Auth token
 * @param {String} id Prayer request reply id
 * @returns {import('axios').AxiosResponse<{ message: String, data: Reply }>}
 */
export function getReplyById (authToken, id) {
  useAuthTokenError(authToken)

  return $axios(`/prayerRequests/prayerRequestReplies/${id}`, {
    headers: {
      'x-access-token': authToken
    }
  })
}

/**
 * Updates a single reply to a prayer request.
 * @param {String} authToken Auth token
 * @param {String} id Prayer request reply id
 * @param {Reply} payload Prayer request reply payload
 * @returns {import('axios').AxiosResponse<{ status: String, data: Reply }>}
 */
export function updateReply (authToken, id, payload) {
  useAuthTokenError(authToken)
  // Same validation for creation is used for updating a prayer request reply
  validateCreateReply(payload)

  return $axios(`/prayerRequests/prayerRequestReplies/${id}`, {
    method: 'PUT',
    headers: {
      Authorization: authToken,
      'x-access-token': authToken
    },
    data: payload
  })
}

/**
 * Deletes a single reply to a prayer request.
 * @param {String} authToken Auth token
 * @param {String} id Prayer request reply id
 * @returns {import('axios').AxiosResponse<{ message: String }>}
 */
export function deleteReply (authToken, id) {
  useAuthTokenError(authToken)

  return $axios(`/prayerRequests/prayerRequestReplies/${id}`, {
    method: 'DELETE',
    headers: {
      Authorization: authToken,
      'x-access-token': authToken
    }
  })
}
